import axios from 'axios';

const api = axios.create({
  baseURL: 'https://demo.emilite.io/api/v1',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for handling token expiration
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/login') &&
      !originalRequest.url.includes('/auth/refresh')
    ) {
      originalRequest._retry = true;
      
      try {
        await api.post('/auth/refresh');
        // After successful refresh, retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        // Don't immediately redirect to login if refresh fails
        // Instead, check if the cookie is still present
        const cookies = document.cookie.split(';');
        const hasAccessToken = cookies.some(cookie => 
          cookie.trim().startsWith('access_token=')
        );
        
        if (!hasAccessToken) {
          window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api; 